<div class="tab-nav">
  <div class="tab-nav__left">
    <div
      class="tab-nav__left__items"
      cdkDropListOrientation="horizontal"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
    >
      @if (!editMode) {
        <div mat-tab-nav-bar animationDuration="0ms">
          @for (tab of tabs; track $index) {
            <div
              class="tab-nav__left__items__item"
              (click)="editMode ? null : onTabClick(tab.id)"
              mat-tab-link
              [active]="tab.id === tabId"
              [disabled]="editMode"
            >
              {{ tab.name }}
            </div>
          }
        </div>
      } @else {
        @for (tab of tabs; track $index) {
          <div
            class="tab-nav__left__items__edit-item"
            cdkDragBoundary=".tab-nav__left__items__item"
            cdkDragLockAxis="x"
            cdkDrag
            [cdkDragDisabled]="!editMode"
          >
            @if (editMode) {
              <mat-icon cdkDragHandle class="drag-icon">drag_indicator</mat-icon>
            }
            {{ tab.name }}
            @if (editMode && tabId !== tab.id) {
              <div class="tab-nav__left__items__edit-item__actions">
                <ts-button
                  matTooltip="Edit Tab Title"
                  type="icon"
                  icon="edit"
                  class="mat-sm-icon edit-tab-title-control"
                  (click)="openTabPanel(tab)"
                  color="basic"
                ></ts-button>
                <ts-button
                  matTooltip="Remove Tab"
                  type="icon"
                  icon="delete"
                  class="mat-sm-icon remove-tab-control"
                  (click)="removeTab(tab)"
                  color="basic"
                ></ts-button>
              </div>
            }
          </div>
        }
      }
    </div>
    @if (editMode) {
      <button class="px-3 mr-1 mt-0.5 ml-3" mat-button #tabPanelOrigin (click)="openTabPanel()">
        <mat-icon class="icon-size-20 mr-2" svgIcon="add_circle"></mat-icon>
        <span>Add Tab</span>
      </button>
      <button class="px-3 mr-1 mt-0.5 ml-3" mat-button [matMenuTriggerFor]="addPanelMenu">
        <mat-icon class="icon-size-20 mr-2" svgIcon="add_circle"></mat-icon>
        <span>Add Panel</span>
      </button>
    }
  </div>
  <div class="tab-nav__right">
    @if (!editMode) {
      <ts-button
        [disabled]="!canEditLayout"
        color="basic"
        class="px-3 mr-1"
        icon="ts_pen"
        (click)="toggleEditMode.emit()"
        [appAuthorize]="PermissionSlot.MANAGE_LAYOUT | jupiterPermissionSlot"
        denyAction="disable"
        >Edit Layout</ts-button
      >
    } @else {
      <ts-button color="basic" icon="ts_close" (click)="layoutCanceled.emit()">Cancel</ts-button>
      <ts-button color="primary" class="px-3 mr-1" icon="save" (click)="layoutSaved.emit()">Save</ts-button>
    }
  </div>
</div>
<mat-menu #addPanelMenu>
  @for (panel of panels; track $index) {
    @if (panel.type === 'table') {
      <button
        mat-menu-item
        [matMenuTriggerFor]="relatedObjectsTable"
        [disabled]="!hasLinkedObjects()"
        [matTooltip]="hasLinkedObjects() ? undefined : 'No linked objects to add table'"
      >
        <mat-icon svgIcon="add"></mat-icon>
        <span>{{ panel.title }}</span>
      </button>
    } @else {
      <button mat-menu-item (click)="panelAdded.emit(panel)">
        <mat-icon svgIcon="add"></mat-icon>
        <span>{{ panel.title }}</span>
      </button>
    }
    @if (panels.length > 1) {
      <mat-divider></mat-divider>
    }
  }
</mat-menu>
<ng-template #tabPanel>
  <div class="tab-form">
    <form [formGroup]="tabForm">
      <input formControlName="id" type="hidden" />
      <input formControlName="name" type="text" placeholder="Tab Name" [maxLength]="25" />
      <ts-button
        type="icon"
        icon="save"
        (click)="saveTab()"
        [disabled]="tabForm.get('name').errors"
        matTooltip="Save Tab"
      ></ts-button>
    </form>
  </div>
</ng-template>
<mat-menu #relatedObjectsTable>
  @for (customObject of customObjects$ | async; track $index) {
    <button mat-menu-item (click)="addRelatedTablePanel(customObject)">
      <mat-icon svgIcon="add"></mat-icon>
      <span>{{ customObject.label }}</span>
    </button>
  }
</mat-menu>
